import { apiV2 } from '../axios';
import { reinviteUser } from "./user-services";

export const reinviteCsw = async (cswId) => {
	return await reinviteUser(cswId);
};

export const acceptStandaloneSwInvite = async (body) => {
	return await apiV2.post('/standalone/social-worker/accept', body);
};
